import React from 'react';

import { DescriptionItem, DescriptionList } from '@gogame/components';

export const DynamicAdvertisingTargetDetails = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem label={'Affected level'} field={'dimension.name'} />
      <DescriptionItem
        label={'Secondary affected level'}
        field={'secondaryDimension.name'}
      />
      <DescriptionItem
        label={'Owners'}
        field={'owners'}
        unitsLabel={'owners'}
        valueParser={'commaList'}
        lineClamp={3}
      />
      <DescriptionItem
        label={'Networks'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'networks'}
        unitsLabel={'networks'}
      />
      <DescriptionItem
        label={'Platforms'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'platforms'}
        unitsLabel={'platforms'}
      />
      <DescriptionItem
        label={'Applications'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'applications'}
        unitsLabel={'applications'}
      />
      <DescriptionItem
        label={'Affiliates'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'affiliates'}
        unitsLabel={'affiliates'}
      />
      <DescriptionItem
        label={'Labels'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'labels'}
        unitsLabel={'labels'}
      />
      <DescriptionItem
        label={'Countries'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'countries'}
        unitsLabel={'countries'}
      />
      <DescriptionItem
        label={'Campaigns'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'campaigns'}
        unitsLabel={'campaigns'}
      />
      <DescriptionItem
        label={'Partner campaigns'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'partnerCampaigns'}
        unitsLabel={'partner campaigns'}
      />
      <DescriptionItem
        label={'AdSets'}
        valueParser={'commaList'}
        lineClamp={3}
        field={'adSets'}
        unitsLabel={'adsets'}
      />
      <DescriptionItem
        label={'Social Media Platforms'}
        field={'socialMediaPlatforms'}
        valueParser={'commaList'}
        lineClamp={3}
        unitsLabel={'Social Media Platforms'}
      />
      <DescriptionItem
        label={'Master Campaigns'}
        field={'masterCampaigns'}
        valueParser={'commaList'}
        lineClamp={3}
        unitsLabel={'Master Campaigns'}
      />
      <DescriptionItem
        label={'Influencer Campaigns'}
        field={'influencerCampaigns'}
        valueParser={'commaList'}
        lineClamp={3}
        unitsLabel={'Influencer Campaigns'}
      />
      <DescriptionItem
        label={'Traffic type'}
        field={'trafficType.name'}
      />
    </DescriptionList>
  );
};
